/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls';
// eslint-disable-next-line no-restricted-imports
import { removeRecentBoardByID, State } from 'modules';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styles from './board-buttons.less';
import { BoardHeaderButton } from './button';

// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
const format = forTemplate('board_list_item');

interface CloseBoardButtonProps {
  readonly idBoard: string;
  readonly tabIndex?: number;
  onClick(): void;
}

class CloseBoardButton extends React.Component<CloseBoardButtonProps> {
  render() {
    const { onClick, tabIndex }: CloseBoardButtonProps = this.props;

    return (
      <BoardHeaderButton
        className={styles.closeButton}
        icon={IconName.Close}
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
        tabIndex={tabIndex}
        title={format('click-to-remove-this-board-from-your-recent-boards')}
      />
    );
  }
}

const mapStateToProps = (state: State, ownProps: CloseBoardButtonProps) => {
  const { idBoard, onClick } = ownProps;

  return {
    idBoard,
    onClick,
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
  ownProps: CloseBoardButtonProps,
) => {
  const { idBoard } = ownProps;

  return {
    onClick() {
      dispatch(removeRecentBoardByID(idBoard));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CloseBoardButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/board-buttons/close-board-button.tsx